import { render, staticRenderFns } from "./AboutComplex.vue?vue&type=template&id=1f0a5666&scoped=true&"
import script from "./AboutComplex.vue?vue&type=script&lang=js&"
export * from "./AboutComplex.vue?vue&type=script&lang=js&"
import style0 from "./AboutComplex.vue?vue&type=style&index=0&id=1f0a5666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a5666",
  null
  
)

export default component.exports